<!-- <body> -->
    <div class="dash">
        <app-sidebar></app-sidebar>
        <div class="dash-app">
            <app-header></app-header>
            <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#staticBackdrop">Add</button>
            <table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">First</th>
      <th scope="col">PhoneNo</th>
      <th scope="col">Percent</th>
      <th scope="col">Email</th>
      <th scope="col">User</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of showdata;let index=index">
      <th scope="row">{{index+1}}</th>
      <td>{{data?.name}}</td>
      <td>{{data?.phoneNo}}</td>
      <td>{{data?.percent}}</td>
      <td>{{data?.email}}</td>
      <td><i class="fa fa-pencil"  data-toggle="modal" data-target="#myModal"></i>
      <i class="fa fa-trash" (click)="deletRefrence(data?._id)" style="margin-left: 12px;" aria-hidden="true"></i></td>
    </tr>
    </tbody>
    </table>
        </div>
    </div>
  <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Edit Profile</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <form class="form-group" [formGroup]="refform" (ngSubmit)="Bookrefrence()">
            <input type="text" class="form-control" formControlName="name" aria-placeholder="name" id="name" placeholder="Name" class="form-control"><br>
          <input type="text" class="form-control" formControlName="phoneNo" aria-placeholder="name" id="PhoneNo" placeholder="PhoneNo" class="form-control"><br>
          <input type="text" class="form-control" formControlName="email" aria-placeholder="name" id="Email" placeholder="Email" class="form-control"><br>
          <input type="text" class="form-control" formControlName="percent" aria-placeholder="name" id="Percent" placeholder="Percent" class="form-control">
        <!-- </div> -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" type="submit" class="btn btn-primary">Done</button>
        </div>
    </form>
      </div>
    </div>
  </div>
  <!-- Button trigger modal -->
  <div class="container">
  
    <!-- The Modal -->
    <div class="modal" id="myModal">
      <div class="modal-dialog">
        <div class="modal-content">
        
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Modal Heading</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          
          <!-- Modal body -->
          <div class="modal-body">
            <form class="form-group" [formGroup]="editform" (ngSubmit)="EditRefrence()">
              <input type="text" class="form-control" formControlName="name" aria-placeholder="name" id="name" placeholder="Name" class="form-control"><br>
            <input type="text" class="form-control" formControlName="phoneNo" aria-placeholder="name" id="PhoneNo" placeholder="PhoneNo" class="form-control"><br>
            <input type="text" class="form-control" formControlName="email" aria-placeholder="name" id="Email" placeholder="Email" class="form-control"><br>
            <!-- <input type="text" class="form-control" formControlName="percent" aria-placeholder="name" id="Percent" placeholder="Percent" class="form-control"> -->
          <!-- </div> -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" type="submit" class="btn btn-primary">Done</button>
          </div>
      </form>
          </div>
          
          <!-- Modal footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
          </div>
          
        </div>
      </div>
    </div>
    
  </div>
  